
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function Cookies() {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto py-8 px-4 max-w-4xl">
      <div className="space-y-8">
        <div className="space-y-4">
          <Link to="/">
            <Button variant="ghost" size="sm">← {t('back_to_home')}</Button>
          </Link>
          <h1 className="text-4xl font-bold text-white">{t('cookie_policy')}</h1>
          <p className="text-muted-foreground">{t('last_updated', { date: new Date().toLocaleDateString() })}</p>
        </div>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">{t('what_are_cookies')}</h2>
          <p>{t('what_are_cookies_desc')}</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">{t('how_we_use_cookies')}</h2>
          <p>{t('how_we_use_cookies_desc')}</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>{t('cookie_authentication')}</li>
            <li>{t('cookie_security')}</li>
            <li>{t('cookie_analysis')}</li>
            <li>{t('cookie_preferences')}</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">{t('types_of_cookies')}</h2>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>{t('cookie_essential')}</li>
            <li>{t('cookie_analytical')}</li>
            <li>{t('cookie_functionality')}</li>
          </ul>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">{t('your_choices_cookies')}</h2>
          <p>{t('your_choices_cookies_desc')}</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl font-semibold">{t('cookie_contact')}</h2>
          <p>{t('cookie_contact_desc')}</p>
          <p className="ml-4">{t('contact_email', { email: 'support@preptcine.com' })}</p>
        </section>
      </div>
    </div>
  );
}
